import React, { FC } from "react";
import { faBan } from "@fortawesome/pro-regular-svg-icons/faBan";
import {
  FontAwesomeIcon,
  FontAwesomeIconProps,
} from "@fortawesome/react-fontawesome";

export const Ban: FC<Omit<FontAwesomeIconProps, "icon">> = (props) => (
  <FontAwesomeIcon icon={faBan} {...props} />
);
